import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconDocumentSearchLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 4v6.179-.025V20 4Zm.308 17.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 0 1-.525-1.283V4.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h7.194a1.8 1.8 0 0 1 1.275.527l4.196 4.196a1.8 1.8 0 0 1 .527 1.275v1.354a.7.7 0 0 1-.216.527.742.742 0 0 1-.534.207.725.725 0 0 1-.535-.215.726.726 0 0 1-.215-.535V8.5h-3.6a.87.87 0 0 1-.641-.259.87.87 0 0 1-.259-.641V4H5.308a.294.294 0 0 0-.212.096.294.294 0 0 0-.096.212v15.384c0 .077.032.148.096.212a.294.294 0 0 0 .212.096h5.356c.212 0 .39.072.534.216a.726.726 0 0 1 .216.534.726.726 0 0 1-.216.535.726.726 0 0 1-.534.215H5.308Zm11.194-2.346c.744 0 1.371-.257 1.884-.77.512-.514.768-1.142.768-1.886s-.257-1.371-.77-1.884c-.514-.512-1.142-.768-1.886-.768s-1.371.257-1.884.77c-.512.514-.768 1.142-.768 1.886s.257 1.371.77 1.884c.514.512 1.142.768 1.886.768Zm5.626 2.973a.713.713 0 0 1-.527.207.716.716 0 0 1-.528-.207l-2.212-2.221a3.8 3.8 0 0 1-1.108.559c-.402.126-.82.189-1.253.189-1.154 0-2.135-.404-2.942-1.212-.808-.807-1.212-1.788-1.212-2.942 0-1.154.404-2.135 1.212-2.942.807-.808 1.788-1.212 2.942-1.212 1.154 0 2.135.404 2.942 1.212.808.807 1.212 1.788 1.212 2.942 0 .433-.063.851-.19 1.253a3.8 3.8 0 0 1-.558 1.108l2.221 2.212a.712.712 0 0 1 .207.526.716.716 0 0 1-.206.528Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconDocumentSearchLine;
